import { useEffect } from 'react';

/**
 * Adds the `.in` class to every `.r` element when it scrolls into view.
 * Also walks `[data-stagger]` containers to apply per-child --d delays.
 * Run this on every page mount; idempotent thanks to one-shot observer.
 */
export function useScrollReveal() {
  useEffect(() => {
    document.querySelectorAll('[data-stagger]').forEach((parent) => {
      const step = parseInt(parent.dataset.stagger, 10) || 90;
      Array.from(parent.children).forEach((child, i) => {
        if (child.classList.contains('r')) {
          child.style.setProperty('--d', `${i * step}ms`);
        }
      });
    });

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
    );

    document.querySelectorAll('.r').forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);
}
